import { VisibleStepMetadata, TableRowMetadata } from "pages/application/applicationService";
import "./Metadata.scss";
import useDesktopChecker from "hooks/useDesktopChecker";

const Metadata = ({ metadata }: { metadata: VisibleStepMetadata[] }) => {

  const isDesktop = useDesktopChecker();
  const hasNoTable = Array.isArray(metadata) && metadata[0]?.table == null;
  return (
    <div className={`data ${hasNoTable ? "no-table": ""}`}>
      {metadata.map((item) => (
        <div key={item.text}>
          <div className={`data__label ${hasNoTable ? "no-table": ""}`}>{item.header}</div>
          <div className="data__values">{item.text}</div>
          {item.table && (
            <div className="data__table">
              {item.table.rows.map((row: TableRowMetadata) => (
                  <div key={row.columns[0]} className="data__table__row">
                    <span>{row.columns[0]}</span>
                    <span className="data__table__row__middleColumn"> {row.columns[1]}</span>
                    {(isDesktop || row.columns[2]) &&  <span> {row.columns[2]}</span>}
                  </div>
                ))}
            </div>
          )}
          {item.childItems &&
            <ul>
              {item.childItems?.map(({ text }: VisibleStepMetadata) => (
                <li key={text}>{text}</li>
              ))}
            </ul>
          }
        </div>
      ))}
    </div>
  );
};

export default Metadata;
